module.exports = __webpack_public_path__ + "assets/img/Logitech-VC-2-Article-w960.d21f2867.jpg";